import { memo, useMemo } from 'react';
import { Row, Col, Button } from 'shards-react';

/**
 * Export a component for 404 Page.
 */

const Page404 = ({ height = '100vh' }) => {
	const style = useMemo(() => ({ height }), [height]);
	return (
		<Row noGutters style={style}>
			<Col className='m-auto text-center'>
				<h1 className='text-light font-weight-bold'>404</h1>
				<h3 className='font-weight-bold'>Something went wrong!</h3>
				<p className='text-light'>There was a problem on our end. Please try again later.</p>
				<Button pill tag='a' href='/' theme='warning'>
					Zur Startseite
				</Button>
			</Col>
		</Row>
	);
};

export default memo(Page404);
